class Dropdown {
    constructor() {
        if (Dropdown.instance) return Dropdown.instance;
        this.container = document.querySelector('.location-dropdown-container');

        if(this.container) {
            this.toggleButtons();
            this.handleSelfInputChange();
        }

        Dropdown.instance = this;
    }

    toggleButtons() {
        const dropdownBtns = document.querySelectorAll('.cat-dropdown-btn');

        dropdownBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                // Invoke special close button
                if (event.target.closest('.close-dropdown')) {
                    btn.classList.remove('active');
                    return;
                }

                // Only toggle on button itself and button title
                if (event.target !== btn && !event.target.closest('.btn-title')) {
                    return;
                }

                btn.classList.toggle('active');
            });
        });

        // Close dropdowns when clicking outside (or on a different dropdown)
        document.addEventListener('click', (event) => {
            dropdownBtns.forEach((btn) => {
                if (!btn.contains(event.target)) {
                    btn.classList.remove('active');
                }
            });
        });
    }

    handleSelfInputChange() {
        const inputs = document.querySelectorAll('.cat-dropdown-list input[type="checkbox"]');

        inputs.forEach(input => {
            input.addEventListener('change', (e) => {
                const ancestor = e.target.closest('.cat-entry');

                const event = new CustomEvent('dropdownInputChange', {
                    bubbles: true,
                    detail: {
                        checked: e.target.checked,
                        title: ancestor.querySelector('.name').textContent,
                        value: e.target.value,
                        slug: e.target.name.replace('-categories[]', '')
                    }
                });
                document.dispatchEvent(event);
            });
        });
    }

    uncheckItem(itemId, slug) {
        const input = this.container.querySelector('input[id="' + itemId + '"][name="' + slug + '-categories[]"]');
        if(input) {
            input.checked = false;
        }
    }
}

export default Dropdown;
